import React from 'react';
import { PHYNTEX_REGISTER } from '../../constants/links';

const STEPS = [
  {
    num: "01",
    title: "DAFTAR CXM",
    desc: "Click button below. Buka account percuma. Verifikasi dalam 5 minit je."
  },
  {
    num: "02",
    title: "DEPOSIT & SETUP",
    desc: "Top up account. Pilih leverage sehingga 1:2000. Setup MT4/MT5 platform."
  },
  {
    num: "03",
    title: "START TRADING",
    desc: "Eksekusi trade dengan tight spreads. Join community untuk signals & analysis."
  }
];

function HowItWorksSection() {
  return (
    <section
      id="how-it-works"
      className="relative z-10 min-h-[80vh] flex items-center px-3 md:px-10 py-16 md:py-24 overflow-hidden"
      style={{ perspective: "2000px" }}
      data-testid="how-it-works-section"
    >
      <div className="max-w-5xl mx-auto w-full">
        {/* Header */}
        <div className="text-center mb-14">
          <span id="hiw-badge" className="inline-block px-4 py-2 text-xs font-inter tracking-[0.3em] uppercase text-[#00FF88] border border-[#00FF88]/30 rounded-full mb-4 will-change-transform">
            Getting Started
          </span>
          <h2 id="hiw-title" className="font-teko text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold uppercase tracking-tight text-[#F5F5F5] leading-[0.9] will-change-transform">
            MACAM MANA <span className="text-[#00FF88]" style={{ textShadow: "0 0 20px rgba(0,255,136,0.5)" }}>NAK START?</span>
          </h2>
        </div>

        {/* Steps */}
        <div className="relative grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {/* Connecting line (desktop only) */}
          <div
            className="hidden md:block absolute top-10 left-[16.5%] right-[16.5%] h-[2px] z-0"
            style={{
              background: "linear-gradient(90deg, transparent, rgba(0,255,136,0.3), transparent)"
            }}
          />

          {STEPS.map((step, i) => (
            <div
              key={i}
              className="step-card relative text-center will-change-transform"
              style={{ transformStyle: "preserve-3d" }}
              data-testid={`step-card-${i + 1}`}
            >
              {/* Number circle */}
              <div
                className="relative inline-flex items-center justify-center w-20 h-20 rounded-full border-2 border-[#00FF88] mb-5 z-10"
                style={{
                  background: "rgba(10,10,10,0.9)",
                  boxShadow: "0 0 20px rgba(0,255,136,0.3), inset 0 0 15px rgba(0,255,136,0.08)"
                }}
              >
                <span className="font-teko text-3xl font-bold text-[#00FF88]" style={{ textShadow: "0 0 12px rgba(0,255,136,0.6)" }}>
                  {step.num}
                </span>
              </div>

              <h3 className="font-teko text-xl md:text-2xl font-bold uppercase tracking-wider text-[#F5F5F5] mb-3">
                {step.title}
              </h3>
              <p className="text-sm text-gray-400 font-inter leading-relaxed max-w-xs mx-auto">
                {step.desc}
              </p>
            </div>
          ))}
        </div>

        {/* Inline mini CTA */}
        <div className="text-center mt-12">
          <a
            href={PHYNTEX_REGISTER}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-[#00FF88] border border-[#00FF88]/40 hover:bg-[#00FF88]/10 transition-all duration-300 font-inter text-sm tracking-wider uppercase"
            data-testid="hiw-cta-link"
          >
            Start Step 1 — Register CXM →
          </a>
        </div>
      </div>
    </section>
  );
}

export default HowItWorksSection;
